export enum KeyCode {
  BACKSPACE = 8,
  DELETE = 46,
  ZERO = 48
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/data/key-code.ts